import { render, staticRenderFns } from "./AuditLogsView.vue?vue&type=template&id=5ac59a4f&lang=html&"
import script from "./AuditLogsView.vue?vue&type=script&lang=ts&"
export * from "./AuditLogsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports